<script>
    import { _ } from 'svelte-i18n';
    import SelectionBox from './SelectionBox.svelte';
    import muscles from '../muscles.json';
</script>

{#each muscles as muscle}
    <SelectionBox
        muscleId={muscle.id}
        name="checkbox-{muscle.name}"
    >
        {$_('calculator.muscles.' + muscle.name)}
    </SelectionBox>
{/each}
